var map = {
	"./fabric/all-fabric/C40S140x100-1cmST/C40S140x100-1cmST (thumbnail).jpg": [
		75985,
		75985
	],
	"./fabric/all-fabric/C40S140x100-1cmST/C40S140x100-1cmST.jpg": [
		48876,
		48876
	],
	"./fabric/all-fabric/C40S140x100-1cmST/面料图解释.xls": [
		66446,
		66446
	],
	"./fabric/all-fabric/C40S140x100-3cmST/C40S140x100-3cmST (thumbnail).jpg": [
		39261,
		39261
	],
	"./fabric/all-fabric/C40S140x100-3cmST/C40S140x100-3cmST.jpg": [
		69088,
		69088
	],
	"./fabric/all-fabric/C40S140x100-3cmST/面料图解释.xls": [
		83800,
		83800
	],
	"./fabric/all-fabric/C40S140x100-5mmST/C40S140x100-5mmST (thumbnail).jpg": [
		51669,
		51669
	],
	"./fabric/all-fabric/C40S140x100-5mmST/C40S140x100-5mmST.jpg": [
		72680,
		72680
	],
	"./fabric/all-fabric/C40S140x100-5mmST/面料图解释.xls": [
		79184,
		79184
	],
	"./fabric/all-fabric/C40S140x100-65mm-Checker/C40S140x100-65mm-Checker (thumbnail).jpg": [
		34027,
		34027
	],
	"./fabric/all-fabric/C40S140x100-65mm-Checker/C40S140x100-65mm-Checker.jpg": [
		48982,
		48982
	],
	"./fabric/all-fabric/C40S140x100-65mm-Checker/面料图解释.xls": [
		1189,
		1189
	],
	"./fabric/all-fabric/C40S140x100-Satin weave/C40S140x100-Satin weave (thumbnail).jpg": [
		29925,
		29925
	],
	"./fabric/all-fabric/C40S140x100-Satin weave/C40S140x100-Satin weave.jpg": [
		26008,
		26008
	],
	"./fabric/all-fabric/C40S140x100-Satin weave/面料图解释.xls": [
		6325,
		6325
	],
	"./fabric/all-fabric/C40S140x110-2cmST/C40S140x110-2cmST (thumbnail).jpg": [
		77921,
		77921
	],
	"./fabric/all-fabric/C40S140x110-2cmST/C40S140x110-2cmST.jpg": [
		30940,
		30940
	],
	"./fabric/all-fabric/C40S140x110-2cmST/面料图解释.xls": [
		98490,
		98490
	],
	"./fabric/all-fabric/C40S140x110-3cmST/C40S140x110-3cmST (thumbnail).jpg": [
		11193,
		11193
	],
	"./fabric/all-fabric/C40S140x110-3cmST/C40S140x110-3cmST.jpg": [
		51204,
		51204
	],
	"./fabric/all-fabric/C40S140x110-3cmST/面料图解释.xls": [
		9099,
		9099
	],
	"./fabric/all-fabric/C40S140x110-Satin weave/C40S140x110-Satin weave (thumbnail).jpg": [
		45521,
		45521
	],
	"./fabric/all-fabric/C40S140x110-Satin weave/C40S140x110-Satin weave.jpg": [
		97772,
		97772
	],
	"./fabric/all-fabric/C40S140x110-Satin weave/面料图解释.xls": [
		25306,
		25306
	],
	"./fabric/all-fabric/TC3070-34S130x80 15mm-Checker/TC3070-34S130x80 15mm-Checker (thumbnail).jpg": [
		26329,
		26329
	],
	"./fabric/all-fabric/TC3070-34S130x80 15mm-Checker/TC3070-34S130x80 15mm-Checker.jpg": [
		80196,
		80196
	],
	"./fabric/all-fabric/TC3070-34S130x80 15mm-Checker/面料图解释.xls": [
		45529,
		45529
	],
	"./fabric/all-fabric/TC3070-34S130x80 25mm-Checker/TC3070-34S130x80 25mm-Checker (thumbnail).jpg": [
		43517,
		43517
	],
	"./fabric/all-fabric/TC3070-34S130x80 25mm-Checker/TC3070-34S130x80 25mm-Checker.jpg": [
		36896,
		36896
	],
	"./fabric/all-fabric/TC3070-34S130x80 25mm-Checker/面料图解释.xls": [
		8428,
		8428
	],
	"./fabric/all-fabric/TC3070-34S130x80-1.5cmST/TC3070-34S130x80-1.5cmST (thumbnail).jpg": [
		28099,
		28099
	],
	"./fabric/all-fabric/TC3070-34S130x80-1.5cmST/TC3070-34S130x80-1.5cmST.jpg": [
		98782,
		98782
	],
	"./fabric/all-fabric/TC3070-34S130x80-1.5cmST/面料图解释.xls": [
		39033,
		39033
	],
	"./fabric/all-fabric/TC3070-34S130x80-1cm ST/TC3070-34S 130x80-1cm ST (thumbnail).jpg": [
		56129,
		56129
	],
	"./fabric/all-fabric/TC3070-34S130x80-1cm ST/TC3070-34S 130x80-1cm ST.jpg": [
		39324,
		39324
	],
	"./fabric/all-fabric/TC3070-34S130x80-1cm ST/面料图解释.xls": [
		69636,
		69636
	],
	"./fabric/all-fabric/TC3070-34S130x80-2.5cmST/TC3070-34S130x80-2.5cmST (thumbnail).jpg": [
		67421,
		67421
	],
	"./fabric/all-fabric/TC3070-34S130x80-2.5cmST/TC3070-34S130x80-2.5cmST.jpg": [
		39296,
		39296
	],
	"./fabric/all-fabric/TC3070-34S130x80-2.5cmST/面料图解释.xls": [
		44970,
		44970
	],
	"./fabric/all-fabric/TC3070-34S130x80-Square pattern/TC3070-34S130x80-Square pattern (thumbnail).jpg": [
		52961,
		52961
	],
	"./fabric/all-fabric/TC3070-34S130x80-Square pattern/TC3070-34S130x80-Square pattern.jpg": [
		28540,
		28540
	],
	"./fabric/all-fabric/TC3070-34S130x80-Square pattern/面料图解释.xls": [
		44129,
		44129
	],
	"./fabric/all-fabric/TC3070-40S140x100 2.5cmST/TC3070-40S140x100 2.5cmST (thumbnail).jpg": [
		13393,
		13393
	],
	"./fabric/all-fabric/TC3070-40S140x100 2.5cmST/TC3070-40S140x100 2.5cmST.jpg": [
		64204,
		64204
	],
	"./fabric/all-fabric/TC3070-40S140x100 2.5cmST/面料图解释.xls": [
		39854,
		39854
	],
	"./fabric/all-fabric/TC3070-40S140x100 3cmST/TC3070-40S140x100 3cmST (thumbnail).jpg": [
		47445,
		47445
	],
	"./fabric/all-fabric/TC3070-40S140x100 3cmST/TC3070-40S140x100 3cmST.jpg": [
		25064,
		25064
	],
	"./fabric/all-fabric/TC3070-40S140x100 3cmST/面料图解释.xls": [
		26828,
		26828
	],
	"./fabric/all-fabric/TC3070-40S140x100 60mm-Checker/TC3070-40S140x100 60mm-Checker (thumbnail).jpg": [
		3865,
		3865
	],
	"./fabric/all-fabric/TC3070-40S140x100 60mm-Checker/TC3070-40S140x100 60mm-Checker.jpg": [
		4836,
		4836
	],
	"./fabric/all-fabric/TC3070-40S140x100 60mm-Checker/面料图解释.xls": [
		46496,
		46496
	],
	"./fabric/all-fabric/TC3070-40S140x100 90mm-Checker/TC3070-40S140x100 90mm-Checker (thumbnail).jpg": [
		46955,
		46955
	],
	"./fabric/all-fabric/TC3070-40S140x100 90mm-Checker/TC3070-40S140x100 90mm-Checker.jpg": [
		29878,
		29878
	],
	"./fabric/all-fabric/TC3070-40S140x100 90mm-Checker/面料图解释.xls": [
		18401,
		18401
	],
	"./fabric/all-fabric/TC3070-40S140x100-1cm ST/TC3070-40S140x100-1cm ST (thumbnail).jpg": [
		91875,
		91875
	],
	"./fabric/all-fabric/TC3070-40S140x100-1cm ST/TC3070-40S140x100-1cm ST.jpg": [
		1598,
		1598
	],
	"./fabric/all-fabric/TC3070-40S140x100-1cm ST/面料图解释.xls": [
		14261,
		14261
	],
	"./fabric/all-fabric/TC3070-40S140x100-Line pattern/TC3070-40S140x100-Line pattern (thumbnail).jpg": [
		74683,
		74683
	],
	"./fabric/all-fabric/TC3070-40S140x100-Line pattern/TC3070-40S140x100-Line pattern.jpg": [
		88422,
		88422
	],
	"./fabric/all-fabric/TC3070-40S140x100-Line pattern/面料图解释.xls": [
		80791,
		80791
	],
	"./fabric/all-fabric/TC3070-40S140x100-Polka dot pattern/TC3070-40S140x100-Polka dot pattern (thumbnail).jpg": [
		59021,
		59021
	],
	"./fabric/all-fabric/TC3070-40S140x100-Polka dot pattern/TC3070-40S140x100-Polka dot pattern.jpg": [
		37872,
		37872
	],
	"./fabric/all-fabric/TC3070-40S140x100-Polka dot pattern/面料图解释.xls": [
		7379,
		7379
	],
	"./fabric/all-fabric/TC3070-40S140x100-Satin weave/TC3070-40S140x100-Satin weave (thumbnail).jpg": [
		85353,
		85353
	],
	"./fabric/all-fabric/TC3070-40S140x100-Satin weave/TC3070-40S140x100-Satin weave.jpg": [
		63604,
		63604
	],
	"./fabric/all-fabric/TC3070-40S140x100-Satin weave/面料图解释.xls": [
		86434,
		86434
	],
	"./fabric/all-fabric/TC3070-40S140x100-Square pattern/TC3070-40S140x100-Square pattern (thumbnail).jpg": [
		78457,
		78457
	],
	"./fabric/all-fabric/TC3070-40S140x100-Square pattern/TC3070-40S140x100-Square pattern.jpg": [
		54724,
		54724
	],
	"./fabric/all-fabric/TC3070-40S140x100-Square pattern/面料图解释.xls": [
		2832,
		2832
	],
	"./fabric/all-fabric/TC3070-40S173x80-Wave pattern/TC3070-40S173x80-Wave pattern (thumbnail).jpg": [
		13693,
		13693
	],
	"./fabric/all-fabric/TC3070-40S173x80-Wave pattern/TC3070-40S173x80-Wave pattern.jpg": [
		49280,
		49280
	],
	"./fabric/all-fabric/TC3070-40S173x80-Wave pattern/面料图解释.xls": [
		65381,
		65381
	],
	"./fabric/all-fabric/TC5050-40S140x100 2.5mm-Checker/TC5050-40S140x100 2.5mm-Checker (thumbnail).jpg": [
		91937,
		91937
	],
	"./fabric/all-fabric/TC5050-40S140x100 2.5mm-Checker/TC5050-40S140x100 2.5mm-Checker.jpg": [
		14300,
		14300
	],
	"./fabric/all-fabric/TC5050-40S140x100 2.5mm-Checker/面料图解释.xls": [
		98143,
		98143
	],
	"./fabric/all-fabric/TC5050-40S140x100 2cmST/TC5050-40S140x100 2cmST (thumbnail).jpg": [
		82557,
		82557
	],
	"./fabric/all-fabric/TC5050-40S140x100 2cmST/TC5050-40S140x100 2cmST.jpg": [
		79776,
		79776
	],
	"./fabric/all-fabric/TC5050-40S140x100 2cmST/面料图解释.xls": [
		29801,
		29801
	],
	"./fabric/all-fabric/TC5050-40S140x100 3cmST/TC5050-40S140x100 3cmST (thumbnail).jpg": [
		59213,
		59213
	],
	"./fabric/all-fabric/TC5050-40S140x100 3cmST/TC5050-40S140x100 3cmST.jpg": [
		81104,
		81104
	],
	"./fabric/all-fabric/TC5050-40S140x100 3cmST/面料图解释.xls": [
		6200,
		6200
	],
	"./fabric/all-fabric/TC5050-40S140x100 5mm-Checker/TC5050-40S140x100 5mm-Checker (thumbnail).jpg": [
		53541,
		53541
	],
	"./fabric/all-fabric/TC5050-40S140x100 5mm-Checker/TC5050-40S140x100 5mm-Checker.jpg": [
		42008,
		42008
	],
	"./fabric/all-fabric/TC5050-40S140x100 5mm-Checker/面料图解释.xls": [
		60991,
		60991
	],
	"./fabric/all-fabric/TC5050-40S140x100-1cmST/TC5050-40S140x100-1cmST (thumbnail).jpg": [
		89613,
		89613
	],
	"./fabric/all-fabric/TC5050-40S140x100-1cmST/TC5050-40S140x100-1cmST.jpg": [
		76944,
		76944
	],
	"./fabric/all-fabric/TC5050-40S140x100-1cmST/面料图解释.xls": [
		82833,
		82833
	],
	"./fabric/all-fabric/thumbnail/C40S140x100-1cmST (thumbnail).jpg": [
		41084,
		41084
	],
	"./fabric/cover/cover.png": [
		40940,
		18559
	],
	"./hospital/cover/cover.png": [
		96749,
		96749
	],
	"./hospital/nurse-dress/GS-NU001/GS-NU001 (thumbnail).jpg": [
		8104,
		8104
	],
	"./hospital/nurse-dress/GS-NU001/GS-NU001-1.jpg": [
		86475,
		86475
	],
	"./hospital/nurse-dress/GS-NU001/GS-NU001-2.jpg": [
		2428,
		2428
	],
	"./hospital/nurse-dress/GS-NU001/GS-NU001-3.jpg": [
		16153,
		16153
	],
	"./hospital/nurse-dress/GS-NU001/GS-NU001.jpg": [
		61473,
		61473
	],
	"./hospital/nurse-dress/GS-NU001/GS-NU001说明.xlsx": [
		61046,
		61046
	],
	"./hospital/nurse-dress/thumbnail/GS-NU001 (thumbnail).jpg": [
		42309,
		42309
	],
	"./hospital/others/GS-NV001/GS-NV001 (thumbnail).jpg": [
		81408,
		81408
	],
	"./hospital/others/GS-NV001/GS-NV001.jpg": [
		15049,
		15049
	],
	"./hospital/others/thumbnail/GS-NV001 (thumbnail).jpg": [
		36222,
		36222
	],
	"./hospital/patient-clothes/GS-HW001/GS-HW001 (thumbnail).jpg": [
		1637,
		1637
	],
	"./hospital/patient-clothes/GS-HW001/GS-HW001-1.jpg": [
		870,
		870
	],
	"./hospital/patient-clothes/GS-HW001/GS-HW001.jpg": [
		29112,
		29112
	],
	"./hospital/patient-clothes/GS-HW001/GS-HW001说明.xlsx": [
		98113,
		98113
	],
	"./hospital/patient-clothes/GS-HW002/GS-HW002 (thumbnail).jpg": [
		10507,
		10507
	],
	"./hospital/patient-clothes/GS-HW002/GS-HW002-1.jpg": [
		48420,
		48420
	],
	"./hospital/patient-clothes/GS-HW002/GS-HW002-2.jpg": [
		48467,
		48467
	],
	"./hospital/patient-clothes/GS-HW002/GS-HW002-3.jpg": [
		76854,
		76854
	],
	"./hospital/patient-clothes/GS-HW002/GS-HW002-4.jpg": [
		33725,
		33725
	],
	"./hospital/patient-clothes/GS-HW002/GS-HW002-5.jpg": [
		8160,
		8160
	],
	"./hospital/patient-clothes/GS-HW002/GS-HW002.jpg": [
		39862,
		39862
	],
	"./hospital/patient-clothes/GS-HW002/GS-HW002说明.xlsx": [
		54411,
		54411
	],
	"./hospital/patient-clothes/GS-HW003/GS-HW003 (thumbnail).jpg": [
		20321,
		20321
	],
	"./hospital/patient-clothes/GS-HW003/GS-HW003-1.jpg": [
		41218,
		41218
	],
	"./hospital/patient-clothes/GS-HW003/GS-HW003-2.jpg": [
		87149,
		87149
	],
	"./hospital/patient-clothes/GS-HW003/GS-HW003-3.jpg": [
		34928,
		34928
	],
	"./hospital/patient-clothes/GS-HW003/GS-HW003.jpg": [
		40860,
		40860
	],
	"./hospital/patient-clothes/GS-HW003/GS-HW003说明.xlsx": [
		13001,
		13001
	],
	"./hospital/patient-clothes/GS-HW004/GS-HW004 (thumbnail).jpg": [
		76771,
		76771
	],
	"./hospital/patient-clothes/GS-HW004/GS-HW004-1.jpg": [
		94556,
		94556
	],
	"./hospital/patient-clothes/GS-HW004/GS-HW004-2.jpg": [
		62251,
		62251
	],
	"./hospital/patient-clothes/GS-HW004/GS-HW004.jpg": [
		80702,
		80702
	],
	"./hospital/patient-clothes/GS-HW004/GS-HW004说明.xlsx": [
		50519,
		50519
	],
	"./hospital/patient-clothes/GS-HW005/GS-HW005 (thumbnail).jpg": [
		21757,
		21757
	],
	"./hospital/patient-clothes/GS-HW005/GS-HW005-1.jpg": [
		38142,
		38142
	],
	"./hospital/patient-clothes/GS-HW005/GS-HW005-2.jpg": [
		34089,
		34089
	],
	"./hospital/patient-clothes/GS-HW005/GS-HW005-3.jpg": [
		62476,
		62476
	],
	"./hospital/patient-clothes/GS-HW005/GS-HW005.jpg": [
		93824,
		93824
	],
	"./hospital/patient-clothes/GS-HW005/GS-HW005说明.xlsx": [
		29169,
		29169
	],
	"./hospital/patient-clothes/GS-HW006/GS-HW006 (thumbnail).jpg": [
		54555,
		54555
	],
	"./hospital/patient-clothes/GS-HW006/GS-HW006-1.jpg": [
		70452,
		70452
	],
	"./hospital/patient-clothes/GS-HW006/GS-HW006-2.jpg": [
		16515,
		16515
	],
	"./hospital/patient-clothes/GS-HW006/GS-HW006-3.jpg": [
		26406,
		26406
	],
	"./hospital/patient-clothes/GS-HW006/GS-HW006.jpg": [
		37414,
		37414
	],
	"./hospital/patient-clothes/GS-HW006/GS-HW006说明.xlsx": [
		40779,
		40779
	],
	"./hospital/patient-clothes/GS-HW007/GS-HW007 (thumbnail).jpg": [
		36737,
		36737
	],
	"./hospital/patient-clothes/GS-HW007/GS-HW007-1.jpg": [
		40194,
		40194
	],
	"./hospital/patient-clothes/GS-HW007/GS-HW007-2.jpg": [
		88685,
		88685
	],
	"./hospital/patient-clothes/GS-HW007/GS-HW007-3.jpg": [
		45232,
		45232
	],
	"./hospital/patient-clothes/GS-HW007/GS-HW007.jpg": [
		29052,
		29052
	],
	"./hospital/patient-clothes/GS-HW007/GS-HW007说明.xlsx": [
		65049,
		65049
	],
	"./hospital/patient-clothes/GS-HW008/GS-HW008 (thumbnail).jpg": [
		31459,
		31459
	],
	"./hospital/patient-clothes/GS-HW008/GS-HW008-1.jpg": [
		26268,
		26268
	],
	"./hospital/patient-clothes/GS-HW008/GS-HW008-2.jpg": [
		51435,
		51435
	],
	"./hospital/patient-clothes/GS-HW008/GS-HW008-3.jpg": [
		55598,
		55598
	],
	"./hospital/patient-clothes/GS-HW008/GS-HW008-4.jpg": [
		9013,
		9013
	],
	"./hospital/patient-clothes/GS-HW008/GS-HW008-5.jpg": [
		47832,
		47832
	],
	"./hospital/patient-clothes/GS-HW008/GS-HW008.jpg": [
		50270,
		50270
	],
	"./hospital/patient-clothes/GS-HW008/GS-HW008说明.xlsx": [
		63903,
		63903
	],
	"./hospital/patient-clothes/GS-HW009/GS-HW009 (thumbnail).jpg": [
		77301,
		77301
	],
	"./hospital/patient-clothes/GS-HW009/GS-HW009-1.jpg": [
		56438,
		56438
	],
	"./hospital/patient-clothes/GS-HW009/GS-HW009-2.jpg": [
		46017,
		46017
	],
	"./hospital/patient-clothes/GS-HW009/GS-HW009-pattern-1.jpg": [
		69871,
		69871
	],
	"./hospital/patient-clothes/GS-HW009/GS-HW009-pattern-10.jpg": [
		75039,
		75039
	],
	"./hospital/patient-clothes/GS-HW009/GS-HW009-pattern-2.jpg": [
		56256,
		56256
	],
	"./hospital/patient-clothes/GS-HW009/GS-HW009-pattern-3.jpg": [
		11837,
		11837
	],
	"./hospital/patient-clothes/GS-HW009/GS-HW009-pattern-4.jpg": [
		64022,
		64022
	],
	"./hospital/patient-clothes/GS-HW009/GS-HW009-pattern-5.jpg": [
		27187,
		27187
	],
	"./hospital/patient-clothes/GS-HW009/GS-HW009-pattern-6.jpg": [
		91908,
		91908
	],
	"./hospital/patient-clothes/GS-HW009/GS-HW009-pattern-7.jpg": [
		69953,
		69953
	],
	"./hospital/patient-clothes/GS-HW009/GS-HW009-pattern-8.jpg": [
		78810,
		78810
	],
	"./hospital/patient-clothes/GS-HW009/GS-HW009-pattern-9.jpg": [
		73271,
		73271
	],
	"./hospital/patient-clothes/GS-HW009/GS-HW009.jpg": [
		53704,
		53704
	],
	"./hospital/patient-clothes/GS-HW009/GS-HW009说明.xlsx": [
		54545,
		54545
	],
	"./hospital/patient-clothes/GS-HW010/GS-HW010 (thumbnail).jpg": [
		69061,
		69061
	],
	"./hospital/patient-clothes/GS-HW010/GS-HW010-1.jpg": [
		56326,
		56326
	],
	"./hospital/patient-clothes/GS-HW010/GS-HW010-2.jpg": [
		14097,
		14097
	],
	"./hospital/patient-clothes/GS-HW010/GS-HW010-3.jpg": [
		35572,
		35572
	],
	"./hospital/patient-clothes/GS-HW010/GS-HW010-pattern-1.jpg": [
		24223,
		24223
	],
	"./hospital/patient-clothes/GS-HW010/GS-HW010-pattern-10.jpg": [
		42703,
		42703
	],
	"./hospital/patient-clothes/GS-HW010/GS-HW010-pattern-2.jpg": [
		39888,
		39888
	],
	"./hospital/patient-clothes/GS-HW010/GS-HW010-pattern-3.jpg": [
		40813,
		40813
	],
	"./hospital/patient-clothes/GS-HW010/GS-HW010-pattern-4.jpg": [
		43014,
		43014
	],
	"./hospital/patient-clothes/GS-HW010/GS-HW010-pattern-5.jpg": [
		81539,
		81539
	],
	"./hospital/patient-clothes/GS-HW010/GS-HW010-pattern-6.jpg": [
		87060,
		87060
	],
	"./hospital/patient-clothes/GS-HW010/GS-HW010-pattern-7.jpg": [
		785,
		785
	],
	"./hospital/patient-clothes/GS-HW010/GS-HW010-pattern-8.jpg": [
		38730,
		38730
	],
	"./hospital/patient-clothes/GS-HW010/GS-HW010-pattern-9.jpg": [
		50887,
		50887
	],
	"./hospital/patient-clothes/GS-HW010/GS-HW010.jpg": [
		50776,
		50776
	],
	"./hospital/patient-clothes/GS-HW010/GS-HW010说明.xlsx": [
		73865,
		73865
	],
	"./hospital/patient-clothes/thumbnail/GS-HW001 (thumbnail).jpg": [
		22694,
		22694
	],
	"./hospital/scrubs/GS-SG001/GS-SG001 (thumbnail).jpg": [
		28069,
		28069
	],
	"./hospital/scrubs/GS-SG001/GS-SG001-1.jpg": [
		53798,
		53798
	],
	"./hospital/scrubs/GS-SG001/GS-SG001-2.jpg": [
		97905,
		97905
	],
	"./hospital/scrubs/GS-SG001/GS-SG001-3.jpg": [
		67220,
		67220
	],
	"./hospital/scrubs/GS-SG001/GS-SG001-4.jpg": [
		35007,
		35007
	],
	"./hospital/scrubs/GS-SG001/GS-SG001.jpg": [
		9816,
		9816
	],
	"./hospital/scrubs/GS-SG001/GS-SG001说明.xlsx": [
		2983,
		2983
	],
	"./hospital/scrubs/thumbnail/GS-SG001 (thumbnail).jpg": [
		2359,
		2359
	],
	"./hospital/thumbNail/thumbNail.png": [
		5969,
		5969
	],
	"./hospital/thumbNail/thumbNail2.png": [
		45687,
		45687
	],
	"./hospital/undergarments/GS-M001/GS-M001 (thumbnail).jpg": [
		94778,
		94778
	],
	"./hospital/undergarments/GS-M001/GS-M001-1.jpg": [
		16493,
		16493
	],
	"./hospital/undergarments/GS-M001/GS-M001-2.jpg": [
		70562,
		70562
	],
	"./hospital/undergarments/GS-M001/GS-M001.jpg": [
		32131,
		32131
	],
	"./hospital/undergarments/GS-M001/GS-M001.xlsx": [
		91958,
		91958
	],
	"./hospital/undergarments/thumbnail/GS-M001 (thumbnail).jpg": [
		79819,
		79819
	],
	"./hospital/waterproof-sheets/GS-WPS001/GS-WPS001 (thumbnail).jpg": [
		44211,
		44211
	],
	"./hospital/waterproof-sheets/GS-WPS001/GS-WPS001-1.jpg": [
		63020,
		63020
	],
	"./hospital/waterproof-sheets/GS-WPS001/GS-WPS001.jpg": [
		31598,
		31598
	],
	"./hospital/waterproof-sheets/GS-WPS001/GS-WPS001说明.xlsx": [
		54615,
		54615
	],
	"./hospital/waterproof-sheets/GS-WPS002/GS-WPS002 (thumbnail).jpg": [
		18323,
		18323
	],
	"./hospital/waterproof-sheets/GS-WPS002/GS-WPS002-1.jpg": [
		18559,
		40940
	],
	"./hospital/waterproof-sheets/GS-WPS002/GS-WPS002.jpg": [
		6606,
		6606
	],
	"./hospital/waterproof-sheets/GS-WPS002/GS-WPS002说明.xlsx": [
		78791,
		78791
	],
	"./hospital/waterproof-sheets/GS-WPS003/GS-WPS003 (thumbnail).jpg": [
		51275,
		51275
	],
	"./hospital/waterproof-sheets/GS-WPS003/GS-WPS003-1.jpg": [
		79300,
		79300
	],
	"./hospital/waterproof-sheets/GS-WPS003/GS-WPS003.jpg": [
		97526,
		97526
	],
	"./hospital/waterproof-sheets/GS-WPS003/GS-WPS003说明.xlsx": [
		29087,
		29087
	],
	"./hospital/waterproof-sheets/GS-WPS004/GS-WPS004 (thumbnail).jpg": [
		99459,
		99459
	],
	"./hospital/waterproof-sheets/GS-WPS004/GS-WPS004-1.jpg": [
		58428,
		58428
	],
	"./hospital/waterproof-sheets/GS-WPS004/GS-WPS004.jpg": [
		18558,
		18558
	],
	"./hospital/waterproof-sheets/GS-WPS004/GS-WPS004说明.xlsx": [
		9623,
		9623
	],
	"./hospital/waterproof-sheets/GS-WPS005/GS-WPS005 (thumbnail).jpg": [
		55035,
		55035
	],
	"./hospital/waterproof-sheets/GS-WPS005/GS-WPS005-1.jpg": [
		35284,
		35284
	],
	"./hospital/waterproof-sheets/GS-WPS005/GS-WPS005.jpg": [
		19782,
		19782
	],
	"./hospital/waterproof-sheets/GS-WPS005/GS-WPS005说明.xlsx": [
		51279,
		51279
	],
	"./hospital/waterproof-sheets/thumbnail/GS-WPS001 (thumbnail).jpg": [
		19349,
		19349
	],
	"./hotel/bathrobe/GS-BR001/GS-BR001 (thumbnail).jpg": [
		25400,
		25400
	],
	"./hotel/bathrobe/GS-BR001/GS-BR001-1.jpg": [
		4859,
		4859
	],
	"./hotel/bathrobe/GS-BR001/GS-BR001-2.jpg": [
		62060,
		62060
	],
	"./hotel/bathrobe/GS-BR001/GS-BR001.jpg": [
		72753,
		72753
	],
	"./hotel/bathrobe/GS-BR001/GS-BR001说明.xlsx": [
		47514,
		47514
	],
	"./hotel/bathrobe/GS-BR002/GS-BR002 (thumbnail).jpg": [
		96666,
		96666
	],
	"./hotel/bathrobe/GS-BR002/GS-BR002-1.jpg": [
		30061,
		30061
	],
	"./hotel/bathrobe/GS-BR002/GS-BR002-2.jpg": [
		81570,
		81570
	],
	"./hotel/bathrobe/GS-BR002/GS-BR002.jpg": [
		7971,
		7971
	],
	"./hotel/bathrobe/GS-BR002/GS-BR002说明.xlsx": [
		13400,
		13400
	],
	"./hotel/bathrobe/thumbnail/GS-BR001 (thumbnail).jpg": [
		90230,
		90230
	],
	"./hotel/bed-linen/GS-BD001/GS-BD001 (thumbnail).jpg": [
		84985,
		84985
	],
	"./hotel/bed-linen/GS-BD001/GS-BD001-1.jpg": [
		88890,
		88890
	],
	"./hotel/bed-linen/GS-BD001/GS-BD001.jpg": [
		740,
		740
	],
	"./hotel/bed-linen/GS-BD001/GS-BD001说明.xlsx": [
		41787,
		41787
	],
	"./hotel/bed-linen/thumbnail/GS-BD001 (thumbnail).jpg": [
		43003,
		43003
	],
	"./hotel/cover/cover.png": [
		90273,
		90273
	],
	"./hotel/gown/GS-G001/GS-G001 (thumbnail).jpg": [
		98410,
		98410
	],
	"./hotel/gown/GS-G001/GS-G001-1.jpg": [
		7741,
		7741
	],
	"./hotel/gown/GS-G001/GS-G001-2.jpg": [
		97842,
		97842
	],
	"./hotel/gown/GS-G001/GS-G001-3.jpg": [
		65775,
		65775
	],
	"./hotel/gown/GS-G001/GS-G001.jpg": [
		66899,
		66899
	],
	"./hotel/gown/GS-G001/GS-G001说明.xlsx": [
		46276,
		46276
	],
	"./hotel/gown/GS-G002/GS-G001说明.xlsx": [
		71469,
		71469
	],
	"./hotel/gown/GS-G002/GS-G002 (thumbnail).jpg": [
		24134,
		24134
	],
	"./hotel/gown/GS-G002/GS-G002.jpg": [
		90775,
		90775
	],
	"./hotel/gown/GS-G003/GS-G003 (thumbnail).jpg": [
		99230,
		99230
	],
	"./hotel/gown/GS-G003/GS-G003-1.jpg": [
		79217,
		79217
	],
	"./hotel/gown/GS-G003/GS-G003.jpg": [
		51103,
		51103
	],
	"./hotel/gown/GS-G003/GS-G003说明.xlsx": [
		71784,
		71784
	],
	"./hotel/gown/GS-G004/GS-G004 (thumbnail).jpg": [
		88562,
		88562
	],
	"./hotel/gown/GS-G004/GS-G004-1.jpg": [
		42437,
		42437
	],
	"./hotel/gown/GS-G004/GS-G004-2.jpg": [
		85210,
		85210
	],
	"./hotel/gown/GS-G004/GS-G004-3.jpg": [
		53495,
		53495
	],
	"./hotel/gown/GS-G004/GS-G004.jpg": [
		57835,
		57835
	],
	"./hotel/gown/GS-G004/GS-G004说明.xlsx": [
		50796,
		50796
	],
	"./hotel/gown/GS-G005/GS-G005 (thumbnail).jpg": [
		65074,
		65074
	],
	"./hotel/gown/GS-G005/GS-G005-1.jpg": [
		63845,
		63845
	],
	"./hotel/gown/GS-G005/GS-G005-2.jpg": [
		41242,
		41242
	],
	"./hotel/gown/GS-G005/GS-G005.jpg": [
		54699,
		54699
	],
	"./hotel/gown/GS-G005/GS-G005说明.xlsx": [
		48932,
		48932
	],
	"./hotel/gown/GS-G006/GS-G006 (thumbnail).jpg": [
		19910,
		19910
	],
	"./hotel/gown/GS-G006/GS-G006-1.jpg": [
		27353,
		27353
	],
	"./hotel/gown/GS-G006/GS-G006-2.jpg": [
		12334,
		12334
	],
	"./hotel/gown/GS-G006/GS-G006-3.jpg": [
		8171,
		8171
	],
	"./hotel/gown/GS-G006/GS-G006.jpg": [
		66967,
		66967
	],
	"./hotel/gown/GS-G006/GS-G006说明.xlsx": [
		75760,
		75760
	],
	"./hotel/gown/GS-G007/GS-G007 (thumbnail).jpg": [
		41454,
		41454
	],
	"./hotel/gown/GS-G007/GS-G007.jpg": [
		92911,
		92911
	],
	"./hotel/gown/GS-G007/GS-G007说明.xlsx": [
		91472,
		91472
	],
	"./hotel/gown/GS-G008/GS-G008 (thumbnail).jpg": [
		95882,
		95882
	],
	"./hotel/gown/GS-G008/GS-G008-1.jpg": [
		15901,
		15901
	],
	"./hotel/gown/GS-G008/GS-G008-2.jpg": [
		6002,
		6002
	],
	"./hotel/gown/GS-G008/GS-G008.jpg": [
		24243,
		24243
	],
	"./hotel/gown/GS-G008/GS-G008说明.xlsx": [
		70524,
		70524
	],
	"./hotel/gown/GS-G009/GS-G009 (thumbnail).jpg": [
		5450,
		5450
	],
	"./hotel/gown/GS-G009/GS-G009.jpg": [
		3219,
		3219
	],
	"./hotel/gown/GS-G009/GS-G009说明.xlsx": [
		55700,
		55700
	],
	"./hotel/gown/GS-G010/GS-G010 (thumbnail).jpg": [
		3806,
		3806
	],
	"./hotel/gown/GS-G010/GS-G010-1.jpg": [
		26193,
		26193
	],
	"./hotel/gown/GS-G010/GS-G010-2.jpg": [
		68422,
		68422
	],
	"./hotel/gown/GS-G010/GS-G010.jpg": [
		6751,
		6751
	],
	"./hotel/gown/GS-G010/GS-G010说明.xlsx": [
		99912,
		99912
	],
	"./hotel/gown/GS-G011/GS-G011 (thumbnail).jpg": [
		72258,
		72258
	],
	"./hotel/gown/GS-G011/GS-G011.jpg": [
		7899,
		7899
	],
	"./hotel/gown/GS-G011/GS-G011说明.xlsx": [
		80620,
		80620
	],
	"./hotel/gown/GS-G012/GS-G012 (thumbnail).jpg": [
		15886,
		15886
	],
	"./hotel/gown/GS-G012/GS-G012-1.jpg": [
		24289,
		24289
	],
	"./hotel/gown/GS-G012/GS-G012.jpg": [
		17135,
		17135
	],
	"./hotel/gown/GS-G012/GS-G012说明.xlsx": [
		9792,
		9792
	],
	"./hotel/gown/GS-G013/GS-G013 (thumbnail).jpg": [
		15498,
		15498
	],
	"./hotel/gown/GS-G013/GS-G013-1.jpg": [
		41373,
		41373
	],
	"./hotel/gown/GS-G013/GS-G013.jpg": [
		82323,
		82323
	],
	"./hotel/gown/GS-G013/GS-G013说明.xlsx": [
		51900,
		51900
	],
	"./hotel/gown/thumbnail/GS-G001 (thumbnail).jpg": [
		44273,
		44273
	],
	"./hotel/others/GS-SL001/GS-SL001 (thumbnail).jpg": [
		14910,
		14910
	],
	"./hotel/others/GS-SL001/GS-SL001.jpg": [
		95743,
		95743
	],
	"./hotel/others/GS-SL002/GS-SL002 (thumbnail).jpg": [
		79864,
		79864
	],
	"./hotel/others/GS-SL002/GS-SL002.jpg": [
		63473,
		63473
	],
	"./hotel/others/GS-SL003/GS-SL003 (thumbnail).jpg": [
		93754,
		93754
	],
	"./hotel/others/GS-SL003/GS-SL003.jpg": [
		10467,
		10467
	],
	"./hotel/others/GS-SL004/GS-SL004 (thumbnail).jpg": [
		58000,
		58000
	],
	"./hotel/others/GS-SL004/GS-SL004.jpg": [
		55481,
		55481
	],
	"./hotel/others/GS-SL005/GS-SL005 (thumbnail).jpg": [
		6806,
		6806
	],
	"./hotel/others/GS-SL005/GS-SL005.jpg": [
		41863,
		41863
	],
	"./hotel/others/GS-SL006/GS-SL006 (thumbnail).jpg": [
		97912,
		97912
	],
	"./hotel/others/GS-SL006/GS-SL006.jpg": [
		69009,
		69009
	],
	"./hotel/others/thumbnail/GS-SL001 (thumbnail).jpg": [
		72221,
		72221
	],
	"./hotel/pajama/GS-P001/GS-P001 (thumbnail).jpg": [
		42251,
		42251
	],
	"./hotel/pajama/GS-P001/GS-P001-1.jpg": [
		87748,
		87748
	],
	"./hotel/pajama/GS-P001/GS-P001-2.jpg": [
		65555,
		65555
	],
	"./hotel/pajama/GS-P001/GS-P001-3.jpg": [
		79094,
		79094
	],
	"./hotel/pajama/GS-P001/GS-P001-4.jpg": [
		50205,
		50205
	],
	"./hotel/pajama/GS-P001/GS-P001.jpg": [
		17846,
		17846
	],
	"./hotel/pajama/GS-P001/GS-P001说明.xlsx": [
		41111,
		41111
	],
	"./hotel/pajama/GS-P002/GS-P002 (thumbnail).jpg": [
		6275,
		6275
	],
	"./hotel/pajama/GS-P002/GS-P002-2.jpg": [
		18251,
		18251
	],
	"./hotel/pajama/GS-P002/GS-P002-3.jpg": [
		22414,
		22414
	],
	"./hotel/pajama/GS-P002/GS-P002.jpg": [
		53694,
		53694
	],
	"./hotel/pajama/GS-P002/GS-P002说明.xlsx": [
		39679,
		39679
	],
	"./hotel/pajama/GS-P003/GS-P003 (thumbnail).jpg": [
		96907,
		96907
	],
	"./hotel/pajama/GS-P003/GS-P003-1.jpg": [
		84196,
		84196
	],
	"./hotel/pajama/GS-P003/GS-P003-2.jpg": [
		84243,
		84243
	],
	"./hotel/pajama/GS-P003/GS-P003-3.jpg": [
		28982,
		28982
	],
	"./hotel/pajama/GS-P003/GS-P003.jpg": [
		84854,
		84854
	],
	"./hotel/pajama/GS-P003/GS-P003说明.xlsx": [
		79679,
		79679
	],
	"./hotel/pajama/thumbnail/GS-P001 (thumbnail).jpg": [
		15233,
		15233
	],
	"./hotel/samue/GS-S001/GS-S001 (thumbnail).jpg": [
		19150,
		19150
	],
	"./hotel/samue/GS-S001/GS-S001-1.jpg": [
		79297,
		79297
	],
	"./hotel/samue/GS-S001/GS-S001-2.jpg": [
		29686,
		29686
	],
	"./hotel/samue/GS-S001/GS-S001-3.jpg": [
		84947,
		84947
	],
	"./hotel/samue/GS-S001/GS-S001.jpg": [
		78351,
		78351
	],
	"./hotel/samue/GS-S001/GS-S001说明.xlsx": [
		51962,
		51962
	],
	"./hotel/samue/GS-S002/GS-S002 (thumbnail).jpg": [
		32266,
		32266
	],
	"./hotel/samue/GS-S002/GS-S002-1.jpg": [
		22845,
		22845
	],
	"./hotel/samue/GS-S002/GS-S002-2.jpg": [
		12946,
		12946
	],
	"./hotel/samue/GS-S002/GS-S002-3.jpg": [
		85327,
		85327
	],
	"./hotel/samue/GS-S002/GS-S002-4.jpg": [
		60388,
		60388
	],
	"./hotel/samue/GS-S002/GS-S002-5.jpg": [
		38433,
		38433
	],
	"./hotel/samue/GS-S002/GS-S002.jpg": [
		16051,
		16051
	],
	"./hotel/samue/GS-S002/GS-S002说明.xlsx": [
		2998,
		2998
	],
	"./hotel/samue/GS-S003/GS-S003 (thumbnail).jpg": [
		98314,
		98314
	],
	"./hotel/samue/GS-S003/GS-S003-1.jpg": [
		75837,
		75837
	],
	"./hotel/samue/GS-S003/GS-S003-2.jpg": [
		65938,
		65938
	],
	"./hotel/samue/GS-S003/GS-S003-3.jpg": [
		33871,
		33871
	],
	"./hotel/samue/GS-S003/GS-S003.jpg": [
		83379,
		83379
	],
	"./hotel/samue/GS-S003/GS-S003说明.xlsx": [
		83062,
		83062
	],
	"./hotel/samue/GS-S004/GS-S004 (thumbnail).jpg": [
		17798,
		17798
	],
	"./hotel/samue/GS-S004/GS-S004-1.jpg": [
		63801,
		63801
	],
	"./hotel/samue/GS-S004/GS-S004-2.jpg": [
		56686,
		56686
	],
	"./hotel/samue/GS-S004/GS-S004.jpg": [
		17751,
		17751
	],
	"./hotel/samue/GS-S004/GS-S004说明.xlsx": [
		42578,
		42578
	],
	"./hotel/samue/GS-S005/GS-S005 (thumbnail).jpg": [
		62694,
		62694
	],
	"./hotel/samue/GS-S005/GS-S005-1.jpg": [
		20089,
		20089
	],
	"./hotel/samue/GS-S005/GS-S005-2.jpg": [
		63950,
		63950
	],
	"./hotel/samue/GS-S005/GS-S005-3.jpg": [
		90411,
		90411
	],
	"./hotel/samue/GS-S005/GS-S005-4.jpg": [
		67576,
		67576
	],
	"./hotel/samue/GS-S005/GS-S005.jpg": [
		92183,
		92183
	],
	"./hotel/samue/GS-S005/GS-S005说明.xlsx": [
		30482,
		30482
	],
	"./hotel/samue/GS-S006/GS-S006 (thumbnail).jpg": [
		9066,
		9066
	],
	"./hotel/samue/GS-S006/GS-S006-1.jpg": [
		76797,
		76797
	],
	"./hotel/samue/GS-S006/GS-S006-2.jpg": [
		38994,
		38994
	],
	"./hotel/samue/GS-S006/GS-S006.jpg": [
		92307,
		92307
	],
	"./hotel/samue/GS-S006/GS-S006说明.xlsx": [
		8982,
		8982
	],
	"./hotel/samue/GS-S007/GS-S007 (thumbnail).jpg": [
		84042,
		84042
	],
	"./hotel/samue/GS-S007/GS-S007-1.jpg": [
		9309,
		9309
	],
	"./hotel/samue/GS-S007/GS-S007-2.jpg": [
		99410,
		99410
	],
	"./hotel/samue/GS-S007/GS-S007-3.jpg": [
		83695,
		83695
	],
	"./hotel/samue/GS-S007/GS-S007.jpg": [
		46899,
		46899
	],
	"./hotel/samue/GS-S007/GS-S007说明.xlsx": [
		71862,
		71862
	],
	"./hotel/samue/GS-S008/GS-S008 (thumbnail).jpg": [
		78878,
		78878
	],
	"./hotel/samue/GS-S008/GS-S008-1.jpg": [
		53777,
		53777
	],
	"./hotel/samue/GS-S008/GS-S008-2.jpg": [
		12358,
		12358
	],
	"./hotel/samue/GS-S008/GS-S008-3.jpg": [
		77059,
		77059
	],
	"./hotel/samue/GS-S008/GS-S008.jpg": [
		61343,
		61343
	],
	"./hotel/samue/GS-S008/GS-S008说明.xlsx": [
		62330,
		62330
	],
	"./hotel/samue/GS-S009/GS-S009 (thumbnail).jpg": [
		27198,
		27198
	],
	"./hotel/samue/GS-S009/GS-S009-1.jpg": [
		96625,
		96625
	],
	"./hotel/samue/GS-S009/GS-S009-2.jpg": [
		68870,
		68870
	],
	"./hotel/samue/GS-S009/GS-S009-3.jpg": [
		12003,
		12003
	],
	"./hotel/samue/GS-S009/GS-S009-4.jpg": [
		35728,
		35728
	],
	"./hotel/samue/GS-S009/GS-S009-5.jpg": [
		87949,
		87949
	],
	"./hotel/samue/GS-S009/GS-S009.jpg": [
		45471,
		45471
	],
	"./hotel/samue/GS-S009/GS-S009说明.xlsx": [
		30554,
		30554
	],
	"./hotel/samue/GS-S010/GS-S010 (thumbnail).jpg": [
		27978,
		27978
	],
	"./hotel/samue/GS-S010/GS-S010-1.jpg": [
		24733,
		24733
	],
	"./hotel/samue/GS-S010/GS-S010-2.jpg": [
		14834,
		14834
	],
	"./hotel/samue/GS-S010/GS-S010-3.jpg": [
		87215,
		87215
	],
	"./hotel/samue/GS-S010/GS-S010-4.jpg": [
		62276,
		62276
	],
	"./hotel/samue/GS-S010/GS-S010-5.jpg": [
		40321,
		40321
	],
	"./hotel/samue/GS-S010/GS-S010.jpg": [
		47155,
		47155
	],
	"./hotel/samue/GS-S010/GS-S010说明.xlsx": [
		19430,
		19430
	],
	"./hotel/samue/thumbnail/GS-S001 (thumbnail).jpg": [
		52633,
		52633
	],
	"./restaurant/cover/cover.png": [
		81722,
		81722
	],
	"./restaurant/glass-towel/GS-TW001/GS-TW001 (thumbnail).jpg": [
		35176,
		35176
	],
	"./restaurant/glass-towel/GS-TW001/GS-TW001.jpg": [
		48065,
		48065
	],
	"./restaurant/glass-towel/GS-TW002/GS-TW002 (thumbnail).jpg": [
		95534,
		95534
	],
	"./restaurant/glass-towel/GS-TW002/GS-TW002.jpg": [
		25615,
		25615
	],
	"./restaurant/glass-towel/GS-TW003/GS-TW003 (thumbnail).jpg": [
		70472,
		70472
	],
	"./restaurant/glass-towel/GS-TW003/GS-TW003.jpg": [
		32545,
		32545
	],
	"./restaurant/glass-towel/thumbnail/GS-TW001 (thumbnail).jpg": [
		89573,
		89573
	],
	"./restaurant/napkin/GS-N001/GS-N001 (thumbnail).jpg": [
		97575,
		97575
	],
	"./restaurant/napkin/GS-N001/GS-N001.jpg": [
		65306,
		65306
	],
	"./restaurant/napkin/GS-N002/GS-N002 (thumbnail).jpg": [
		21539,
		21539
	],
	"./restaurant/napkin/GS-N002/GS-N002.jpg": [
		69182,
		69182
	],
	"./restaurant/napkin/GS-N003/GS-N003 (thumbnail).jpg": [
		79703,
		79703
	],
	"./restaurant/napkin/GS-N003/GS-N003.jpg": [
		32650,
		32650
	],
	"./restaurant/napkin/GS-N004/GS-N004 (thumbnail).jpg": [
		8243,
		8243
	],
	"./restaurant/napkin/GS-N004/GS-N004.jpg": [
		21550,
		21550
	],
	"./restaurant/napkin/GS-N005/GS-N005 (thumbnail).jpg": [
		63175,
		63175
	],
	"./restaurant/napkin/GS-N005/GS-N005.jpg": [
		82266,
		82266
	],
	"./restaurant/napkin/thumbnail/GS-N001 (thumbnail).jpg": [
		94627,
		94627
	],
	"./restaurant/table-cloth/GS-TC001/GS-TC001 (thumbnail).jpg": [
		6193,
		6193
	],
	"./restaurant/table-cloth/GS-TC001/GS-TC001.jpg": [
		68588,
		68588
	],
	"./restaurant/table-cloth/thumbnail/GS-TC001 (thumbnail).jpg": [
		91514,
		91514
	],
	"./spa-and-resort/cover/cover.png": [
		3131,
		3131
	],
	"./spa-and-resort/haori/GS-H001/GS-H001 (thumbnail).jpg": [
		28916,
		28916
	],
	"./spa-and-resort/haori/GS-H001/GS-H001.jpg": [
		63509,
		63509
	],
	"./spa-and-resort/haori/GS-H001/GS-H001说明.xlsx": [
		50054,
		50054
	],
	"./spa-and-resort/haori/thumbnail/GS-H001 (thumbnail).jpg": [
		64470,
		64470
	],
	"./spa-and-resort/others/GS-SL001/GS-SL001 (thumbnail).jpg": [
		12084,
		12084
	],
	"./spa-and-resort/others/GS-SL001/GS-SL001.jpg": [
		27189,
		27189
	],
	"./spa-and-resort/others/GS-SL002/GS-SL002 (thumbnail).jpg": [
		75854,
		75854
	],
	"./spa-and-resort/others/GS-SL002/GS-SL002.jpg": [
		63823,
		63823
	],
	"./spa-and-resort/others/GS-SL003/GS-SL003 (thumbnail).jpg": [
		58728,
		58728
	],
	"./spa-and-resort/others/GS-SL003/GS-SL003.jpg": [
		93313,
		93313
	],
	"./spa-and-resort/others/GS-SL004/GS-SL004 (thumbnail).jpg": [
		68630,
		68630
	],
	"./spa-and-resort/others/GS-SL004/GS-SL004.jpg": [
		85991,
		85991
	],
	"./spa-and-resort/others/GS-SL005/GS-SL005 (thumbnail).jpg": [
		83348,
		83348
	],
	"./spa-and-resort/others/GS-SL005/GS-SL005.jpg": [
		82965,
		82965
	],
	"./spa-and-resort/others/GS-SL006/GS-SL006 (thumbnail).jpg": [
		39934,
		39934
	],
	"./spa-and-resort/others/GS-SL006/GS-SL006.jpg": [
		49247,
		49247
	],
	"./spa-and-resort/others/thumbnail/GS-SL001 (thumbnail).jpg": [
		21491,
		21491
	],
	"./spa-and-resort/relax-wear/GS-RW001/GS-RW001 (thumbnail).jpg": [
		68031,
		68031
	],
	"./spa-and-resort/relax-wear/GS-RW001/GS-RW001-1.jpg": [
		95512,
		95512
	],
	"./spa-and-resort/relax-wear/GS-RW001/GS-RW001-2.jpg": [
		75495,
		75495
	],
	"./spa-and-resort/relax-wear/GS-RW001/GS-RW001-3.jpg": [
		7754,
		7754
	],
	"./spa-and-resort/relax-wear/GS-RW001/GS-RW001.jpg": [
		37922,
		37922
	],
	"./spa-and-resort/relax-wear/GS-RW001/GS-RW001说明.xlsx": [
		97281,
		97281
	],
	"./spa-and-resort/relax-wear/GS-RW002/GS-RW002 (thumbnail).jpg": [
		18785,
		18785
	],
	"./spa-and-resort/relax-wear/GS-RW002/GS-RW002-1.jpg": [
		87458,
		87458
	],
	"./spa-and-resort/relax-wear/GS-RW002/GS-RW002-2.jpg": [
		16717,
		16717
	],
	"./spa-and-resort/relax-wear/GS-RW002/GS-RW002.jpg": [
		55388,
		55388
	],
	"./spa-and-resort/relax-wear/GS-RW002/GS-RW002说明.xlsx": [
		4999,
		4999
	],
	"./spa-and-resort/relax-wear/GS-RW003/GS-RW003 (thumbnail).jpg": [
		32563,
		32563
	],
	"./spa-and-resort/relax-wear/GS-RW003/GS-RW003-1.jpg": [
		44748,
		44748
	],
	"./spa-and-resort/relax-wear/GS-RW003/GS-RW003-2.jpg": [
		21723,
		21723
	],
	"./spa-and-resort/relax-wear/GS-RW003/GS-RW003-3.jpg": [
		20414,
		20414
	],
	"./spa-and-resort/relax-wear/GS-RW003/GS-RW003.jpg": [
		23662,
		23662
	],
	"./spa-and-resort/relax-wear/GS-RW003/GS-RW003说明.xlsx": [
		43985,
		43985
	],
	"./spa-and-resort/relax-wear/GS-RW004/GS-RW004 (thumbnail).jpg": [
		15273,
		15273
	],
	"./spa-and-resort/relax-wear/GS-RW004/GS-RW004-1.jpg": [
		27722,
		27722
	],
	"./spa-and-resort/relax-wear/GS-RW004/GS-RW004-2.jpg": [
		53973,
		53973
	],
	"./spa-and-resort/relax-wear/GS-RW004/GS-RW004-3.jpg": [
		46104,
		46104
	],
	"./spa-and-resort/relax-wear/GS-RW004/GS-RW004.jpg": [
		56852,
		56852
	],
	"./spa-and-resort/relax-wear/GS-RW004/GS-RW004说明.xlsx": [
		34675,
		34675
	],
	"./spa-and-resort/relax-wear/thumbnail/GS-RW001 (thumbnail).jpg": [
		94810,
		94810
	],
	"./spa-and-resort/yukata/GS-Y001/GS-Y001 (thumbnail).jpg": [
		82518,
		82518
	],
	"./spa-and-resort/yukata/GS-Y001/GS-Y001.jpg": [
		3111,
		3111
	],
	"./spa-and-resort/yukata/GS-Y001/GS-Y001说明.xlsx": [
		35962,
		35962
	],
	"./spa-and-resort/yukata/thumbnail/GS-Y001 (thumbnail).jpg": [
		18027,
		18027
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 17085;
module.exports = webpackAsyncContext;